import { render, staticRenderFns } from "./custommenu.vue?vue&type=template&id=c0071f8e&scoped=true"
import script from "./custommenu.vue?vue&type=script&lang=js"
export * from "./custommenu.vue?vue&type=script&lang=js"
import style0 from "./custommenu.vue?vue&type=style&index=0&id=c0071f8e&prod&scoped=true&lang=scss"
import style1 from "./custommenu.vue?vue&type=style&index=1&id=c0071f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0071f8e",
  null
  
)

export default component.exports